import { nextTick } from "vue";
import LoanService from "@/service/LoanService";

const SUBJECT_TYPE_MAP = {
    loanId: 'loan',
};

export const SEND_STOPS_CONFIRM_GROUP = 'sendStops';


export function checkSendStops(subjects, subjectType, confirm, toast) {
    const type = SUBJECT_TYPE_MAP[subjectType] !== undefined ? SUBJECT_TYPE_MAP[subjectType] : subjectType;

    return LoanService.checkSendStops(subjects, type).then((res) => {
        const stopped = res && res.subjects ? res.subjects : [];

        if (stopped.length === 0) {
            return subjects;
        }

        return new Promise((resolve) => {
            nextTick(() => {
                confirm.require({
                    group: SEND_STOPS_CONFIRM_GROUP,
                    message: 'Займы найдены в списке остановленных передач. Вы уверены, что хотите их перевыгрузить?',
                    stoppedSubjects: stopped,
                    header: 'Найдены остановленные передачи',
                    icon: 'pi pi-exclamation-triangle',
                    acceptLabel: 'Да',
                    acceptIcon: 'pi pi-check',
                    rejectLabel: 'Нет',
                    rejectIcon: 'pi pi-times',
                    accept: () => resolve(subjects),
                    reject: () => {
                        const stoppedKeys = stopped.map((el) => String(el));
                        const filtered = subjects.filter((el) => !stoppedKeys.includes(String(el)));

                        if (filtered.length === 0) {
                            toast.add({
                                severity: 'warn',
                                summary: 'Отправка отменена',
                                detail: 'Все субъекты находятся в списке остановленных передач.',
                                life: 5000
                            });
                            resolve(null);
                            return;
                        }

                        toast.add({
                            severity: 'info',
                            summary: 'Остановленные передачи исключены',
                            detail: `Исключено субъектов: ${stopped.length}. Отправлено: ${filtered.length}.`,
                            life: 5000
                        });
                        resolve(filtered);
                    },
                    onHide: () => resolve(null),
                });
            });
        });
    });
}

export default checkSendStops;
